export type BackendProjectCategory =
  /** 快测 */
  | 'quick'
  /** 创意诊断 */
  | 'base'
  /** 深度洞察 */
  | 'survey'
export type BackendProductServiceCategory =
  /** 横屏-快测 */
  | 'quick_landscape'
  /** 横屏-创意诊断 */
  | 'base_landscape'
  /** 横屏-深度洞察 */
  | 'survey_landscape'
  /** 竖屏-快测 */
  | 'quick_portrait'
  /** 竖屏-创意诊断 */
  | 'base_portrait'
  /** 竖屏-深度洞察 */
  | 'survey_portrait'
export type ProductOrientation = 'horizontal' | 'portrait'
export type ProductMode =
  /** 快测 */
  | 'quick'
  /** 创意诊断 */
  | 'base'
  /** 深度洞察 */
  | 'survey'
export type ProjectTaskType = 'landscape' | 'portrait'

export const QUICK_PRODUCT_CATEGORIES: ProjectModels.ProjectCategory[] = [
  'horizontal-quick',
  'portrait-quick',
]

export const SURVEY_PRODUCT_CATEGORIES: ProjectModels.ProjectCategory[] = [
  'horizontal-survey',
  'portrait-survey',
]

export const PORTRAIT_PRODUCT_CATEGORIES: ProjectModels.ProjectCategory[] = [
  'portrait-quick',
  'portrait-base',
  'portrait-survey',
]

export const FREE_TRIAL_PRODUCT_CATEGORIES: ProjectModels.ProjectCategory[] = [
  'horizontal-base',
  'horizontal-survey',
  'portrait-base',
  'portrait-survey',
]

export function getProductMode(
  productCategory: ProjectModels.ProjectCategory
): ProductMode {
  if (QUICK_PRODUCT_CATEGORIES.includes(productCategory)) {
    return 'quick'
  }
  return SURVEY_PRODUCT_CATEGORIES.includes(productCategory) ? 'survey' : 'base'
}

export function isQuickProductCategory(productCategory: ProjectModels.ProjectCategory) {
  return getProductMode(productCategory) === 'quick'
}

export function isSurveyProductCategory(productCategory: ProjectModels.ProjectCategory) {
  return getProductMode(productCategory) === 'survey'
}

export function getProductOrientation(
  productCategory: ProjectModels.ProjectCategory
): ProductOrientation {
  return PORTRAIT_PRODUCT_CATEGORIES.includes(productCategory)
    ? 'portrait'
    : 'horizontal'
}

export function isPortraitProductCategory(productCategory: ProjectModels.ProjectCategory) {
  return getProductOrientation(productCategory) === 'portrait'
}

export function isFreeTrialProductCategory(productCategory: ProjectModels.ProjectCategory) {
  return FREE_TRIAL_PRODUCT_CATEGORIES.includes(productCategory)
}

export function isPortraitByProjectInfo(project: {
  projectCategory?: string
  taskType?: string
}) {
  if (project.taskType === 'portrait') {
    return true
  }
  if (project.taskType === 'landscape') {
    return false
  }
  const category = project.projectCategory || ''
  if (category.includes('portrait')) {
    return true
  }
  if (category.includes('landscape')) {
    return false
  }
  return isPortraitProductCategory(category as ProjectModels.ProjectCategory)
}

export function toBackendProjectCategory(
  productCategory: ProjectModels.ProjectCategory
): BackendProjectCategory {
  return getProductMode(productCategory)
}

export function toBackendProductServiceCategory(
  productCategory: ProjectModels.ProjectCategory
): BackendProductServiceCategory {
  const mode = getProductMode(productCategory)
  const orientation = getProductOrientation(productCategory)
  if (orientation === 'portrait') {
    if (mode === 'quick') {
      return 'quick_portrait'
    }
    return mode === 'base' ? 'base_portrait' : 'survey_portrait'
  }
  if (mode === 'quick') {
    return 'quick_landscape'
  }
  return mode === 'base' ? 'base_landscape' : 'survey_landscape'
}

export function toVideoDurationProjectCategory(
  productCategory: ProjectModels.ProjectCategory
): BackendProductServiceCategory {
  return toBackendProductServiceCategory(productCategory)
}

export function toProjectType(productCategory: ProjectModels.ProjectCategory): ProjectModels.ProjectType {
  return isQuickProductCategory(productCategory)
    ? 'ad_creative_selection'
    : 'ad_creative_test'
}
